module.exports = __webpack_public_path__ + "img/alba-minuscules.e1f38b7e.jpg";